import React from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import DoneIcon from "@material-ui/icons/Done";
import AddIcon from "@material-ui/icons/Add";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      flexFlow: "row wrap",
      justifyContent: "space-around"
    },
    containerUser: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "20px",
      padding: "4px"
    },
    mt8: {
      marginTop: "8px"
    },
    icon_attended: {
      color: "#77ffb5"
    },
    icon_not_attended: {
      color: "#E95A58"
    },
    icon_yes: {
      color: "#77ffb5"
    },
    icon_no: {
      color: "#E95A58"
    },
    icon_maybe: {
      color: "#FFE084"
    }
  };
});

var createIconAttendance = function createIconAttendance(classes, status) {
  switch (status) {
    case "yes":
    case "no":
    case "maybe":
      return /*#__PURE__*/React.createElement(DoneIcon, {
        fontSize: "small",
        className: classes["icon_".concat(status)]
      });

    case "attended":
    case "not_attended":
      return /*#__PURE__*/React.createElement(DoneAllIcon, {
        fontSize: "small",
        className: classes["icon_".concat(status)]
      });

    case "injured":
      return /*#__PURE__*/React.createElement(AddIcon, {
        fontSize: "small",
        color: "secondary"
      });

    default:
      return /*#__PURE__*/React.createElement("p", null, "Error");
  }
};

var ListUserAttendance = function ListUserAttendance(props) {
  var classes = useStyles(); // console.log("props list user attendance", props);

  return props.data.map(function (user) {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4,
      md: 3,
      className: classes.containerUser,
      onClick: function onClick() {
        return props.handleClickUser(user.key);
      }
    }, props.logicIcon ? props.logicIcon(classes, user) : createIconAttendance(classes, user.status), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.mt8,
      align: "center"
    }, user.name));
  });
};

export { ListUserAttendance };